import * as Sentry from "@sentry/react";
import { getConfig } from "./config";

export function initSentry() {
  if (!getConfig('REACT_APP_SENTRY_DSN')) {
    return;
  }

  Sentry.init({
    dsn: getConfig('REACT_APP_SENTRY_DSN'),
    environment: getConfig('REACT_APP_ENV'),
    integrations: [Sentry.browserTracingIntegration()],
    allowUrls: [new URL(window.location.origin).hostname],
    tracesSampleRate: Number(getConfig('REACT_APP_SENTRY_SAMPLE_RATE')) || 0,
  });
}
